import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=39b1f862&scoped=true"
import script from "./navbar.vue?vue&type=script&lang=ts"
export * from "./navbar.vue?vue&type=script&lang=ts"
import style0 from "./navbar.vue?vue&type=style&index=0&id=39b1f862&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b1f862",
  null
  
)

export default component.exports